import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const Container = styled.div`
  padding: 16px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid ${COLORS.NEUTRAL_STROKE};
`;

export const ItemsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${media.M` grid-template-columns: 1fr 1fr; `}

  gap: 16px 80px;
  margin: 0 0 16px;
  padding: 0 0 16px;

  border-bottom: 1px solid ${COLORS.NEUTRAL_STROKE};
`;

export const Footer = styled.div`
  gap: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IngredientPanelItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
`;

export const UnavailableProduct = styled.p`
  font-size: 10px;
  line-height: 12px;
  color: ${COLORS.NEUTRAL_DISABLED};
  text-align: center;
  width: 80px;
`;
